export const money = {
    methods: {
        pad(str) {
            return (str || '').toString().padStart(4, '0')
        },
        money(amount, thousand = ',') {
            if (amount === null || amount === undefined) return '0.00';
            let amountStr = amount.toString();

            let parts = amountStr.split('.');

            if (parts[1]) {
                if (parts[1].length == 1) {
                    parts[1] += '0';
                } else if (parts[1].length > 2) {
                    parts[1] = parts[1].substring(0, 2);
                }
            } else {
                parts[1] = '00';
            }

            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand)

            return parts.join('.')
        },
        batchTotal(batch) {
            let total = 0;
            const toNumber = t => {
                let number = parseFloat(t.amount);

                return isNaN(number) ? 0 : number;
            }
            const reducesTo = (prev, current, index) => prev + current

            if (batch.zesa) {
                total += batch.zesa.transactions.map(toNumber).reduce(reducesTo)
            }

            if (batch.bundle) {
                total += batch.bundle.transactions.map(toNumber).reduce(reducesTo)
            }

            if (batch.airtime) {
                total += batch.airtime.transactions.map(toNumber).reduce(reducesTo)
            }

            if (batch.smart) {
                total += batch.smart.transactions.map(toNumber).reduce(reducesTo)
            }

            if (isNaN(total)) return '--.--'

            return total.toFixed(2)
        }
    },
}
